export const categories = [
  { slug: 'shaonian-redixue', name: '少年热血', icon: 'ri-fire-line', description: '热血沸腾的战斗场面，主角不断成长变强的少年漫画。' },
  { slug: 'shaonv-lianai', name: '少女恋爱', icon: 'ri-heart-line', description: '甜蜜浪漫的爱情故事，少女心满满的纯爱漫画。' },
  { slug: 'qihuan-maoxian', name: '奇幻冒险', icon: 'ri-compass-3-line', description: '异世界穿越、魔法冒险，充满想象力的奇幻世界。' },
  { slug: 'danmei-BL', name: '耽美BL', icon: 'ri-star-line', description: '精致画风下的唯美故事，令人心动的耽美漫画。' },
  { slug: 'jingsong-xuanyi', name: '惊悚悬疑', icon: 'ri-ghost-line', description: '扣人心弦的悬疑剧情，令人毛骨悚然的惊悚漫画。' },
  { slug: 'gaoxiao-richang', name: '搞笑日常', icon: 'ri-emotion-laugh-line', description: '轻松搞笑的日常故事，让你捧腹大笑的欢乐漫画。' },
];

export type ManhwaChapter = {
  id: string;
  title: string;
  number: number;
  updateTime: string;
};

export type Manhwa = {
  id: number;
  title: string;
  slug: string;
  category: string;
  cover: string;
  description: string;
  longDescription: string;
  author: string;
  status: '连载中' | '已完结';
  rating: number;
  views: number;
  updateTime: string;
  tags: string[];
  chapters: ManhwaChapter[];
};

export const manhwaList: Manhwa[] = [
  {
    id: 1,
    title: '剑与魔法之王',
    slug: 'sword-and-magic-king',
    category: 'qihuan-maoxian',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20cover%20style%2C%20a%20young%20warrior%20with%20a%20glowing%20sword%20in%20a%20fantasy%20world%2C%20dramatic%20lighting%2C%20detailed%20character%20design%2C%20manga%20illustration%20style%20with%20clean%20lines%20and%20vibrant%20colors%2C%20dark%20background%20with%20magical%20effects&width=600&height=800&seq=manhwa-01&orientation=portrait',
    description: '平凡少年意外觉醒剑与魔法之力，在异世界中踏上成为最强王者的冒险之旅。',
    longDescription: '在平凡的高中生李明被神秘力量卷入异世界之后，他发现自己竟然同时拥有剑术和魔法的双重天赋。在这个充满危险与机遇的世界中，他将结识可靠的伙伴，面对强大的敌人，一步步揭开这个世界隐藏的秘密。剑与魔法交织的史诗冒险，就此展开！',
    author: '金泰亨',
    status: '连载中',
    rating: 4.8,
    views: 1250000,
    updateTime: '2026-08-05',
    tags: ['异世界', '冒险', '成长', '奇幻'],
    chapters: [
      { id: 'ch-1-1', title: '第1话 觉醒之日', number: 1, updateTime: '2026-01-15' },
      { id: 'ch-1-2', title: '第2话 初遇同伴', number: 2, updateTime: '2026-01-22' },
      { id: 'ch-1-3', title: '第3话 第一个任务', number: 3, updateTime: '2026-01-29' },
      { id: 'ch-1-4', title: '第4话 暗影来袭', number: 4, updateTime: '2026-02-05' },
      { id: 'ch-1-5', title: '第5话 力量觉醒', number: 5, updateTime: '2026-02-12' },
    ],
  },
  {
    id: 2,
    title: '甜蜜的陷阱',
    slug: 'sweet-trap',
    category: 'shaonv-lianai',
    cover: 'https://readdy.ai/api/search-image?query=A%20romantic%20Korean%20manhwa%20cover%2C%20a%20beautiful%20couple%20in%20cherry%20blossom%20setting%2C%20soft%20pink%20tones%2C%20delicate%20art%20style%2C%20manga%20illustration%20with%20floating%20petals%20and%20warm%20lighting%2C%20clean%20simple%20background&width=600&height=800&seq=manhwa-02&orientation=portrait',
    description: '职场女强人与温柔男下属之间甜蜜又纠结的办公室恋情，让人心动不已。',
    longDescription: '35岁的职场精英林婉清事业有成，却在爱情上一片空白。当她遇见了新来的助理——温柔体贴又帅气十足的韩俊熙，她的人生开始发生微妙的变化。年龄差、职场规则、前任的出现……这段甜蜜的恋爱之路充满了意想不到的陷阱与惊喜。',
    author: '崔秀英',
    status: '连载中',
    rating: 4.6,
    views: 980000,
    updateTime: '2026-08-04',
    tags: ['职场', '恋爱', '年龄差', '甜宠'],
    chapters: [
      { id: 'ch-2-1', title: '第1话 新来的助理', number: 1, updateTime: '2026-02-01' },
      { id: 'ch-2-2', title: '第2话 加班之夜', number: 2, updateTime: '2026-02-08' },
      { id: 'ch-2-3', title: '第3话 意外的约会', number: 3, updateTime: '2026-02-15' },
      { id: 'ch-2-4', title: '第4话 心跳加速', number: 4, updateTime: '2026-02-22' },
    ],
  },
  {
    id: 3,
    title: '热血格斗传说',
    slug: 'hot-blooded-fighter',
    category: 'shaonian-redixue',
    cover: 'https://readdy.ai/api/search-image?query=A%20shonen%20Korean%20manhwa%20cover%2C%20a%20determined%20young%20fighter%20with%20fiery%20aura%2C%20intense%20action%20pose%2C%20dynamic%20composition%2C%20bold%20red%20and%20orange%20color%20scheme%2C%20manga%20illustration%20with%20speed%20lines%20and%20impact%20effects&width=600&height=800&seq=manhwa-03&orientation=portrait',
    description: '从小被欺负的少年通过刻苦训练，在格斗擂台上一步步证明自己的热血故事。',
    longDescription: '张浩宇从小体弱多病，在学校里总是被欺负的对象。直到有一天，他遇到了一位神秘的格斗大师，从此踏上了格斗之路。汗水、泪水、血水交织，他从一个懦弱的少年成长为擂台上令人敬畏的战士。这不仅是一个关于格斗的故事，更是一个关于勇气、友情和信念的热血传奇。',
    author: '朴正洙',
    status: '已完结',
    rating: 4.9,
    views: 2100000,
    updateTime: '2026-07-20',
    tags: ['格斗', '热血', '成长', '校园'],
    chapters: [
      { id: 'ch-3-1', title: '第1话 弱者的觉醒', number: 1, updateTime: '2025-06-01' },
      { id: 'ch-3-2', title: '第2话 师父的试炼', number: 2, updateTime: '2025-06-08' },
      { id: 'ch-3-3', title: '第3话 首战告捷', number: 3, updateTime: '2025-06-15' },
      { id: 'ch-3-4', title: '第4话 强敌出现', number: 4, updateTime: '2025-06-22' },
      { id: 'ch-3-5', title: '第5话 不屈的意志', number: 5, updateTime: '2025-06-29' },
      { id: 'ch-3-6', title: '第6话 最终决战', number: 6, updateTime: '2025-07-06' },
    ],
  },
  {
    id: 4,
    title: '星塵之歌',
    slug: 'stardust-melody',
    category: 'danmei-BL',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20BL%20Korean%20manhwa%20cover%2C%20two%20elegant%20young%20men%20under%20a%20starry%20night%20sky%2C%20ethereal%20atmosphere%2C%20soft%20purple%20and%20silver%20tones%2C%20delicate%20manga%20art%20style%20with%20dreamy%20lighting%20and%20floating%20stardust&width=600&height=800&seq=manhwa-04&orientation=portrait',
    description: '音乐学院的两位天才少年，在音符中碰撞出的唯美情感故事。',
    longDescription: '在首尔最顶尖的音乐学院里，钢琴天才尹星辰和小提琴王子金黎昕是全校公认的竞争对手。然而在一次联合演出中，两人意外地发现了彼此音乐中隐藏的共鸣。从对抗到理解，从竞争对手到灵魂伴侣，他们的故事如同星辰与旋律交织而成的美丽乐章。',
    author: '李恩在',
    status: '连载中',
    rating: 4.7,
    views: 1560000,
    updateTime: '2026-08-03',
    tags: ['音乐', '校园', '唯美', '治愈'],
    chapters: [
      { id: 'ch-4-1', title: '第1话 不和谐的序曲', number: 1, updateTime: '2026-03-01' },
      { id: 'ch-4-2', title: '第2话 意外的合奏', number: 2, updateTime: '2026-03-08' },
      { id: 'ch-4-3', title: '第3话 琴弦上的心跳', number: 3, updateTime: '2026-03-15' },
    ],
  },
  {
    id: 5,
    title: '暗夜追踪者',
    slug: 'night-tracker',
    category: 'jingsong-xuanyi',
    cover: 'https://readdy.ai/api/search-image?query=A%20thriller%20Korean%20manhwa%20cover%2C%20a%20mysterious%20detective%20in%20a%20dark%20alley%20at%20night%2C%20noir%20atmosphere%2C%20dramatic%20shadows%2C%20muted%20colors%20with%20red%20accents%2C%20manga%20illustration%20with%20tense%20mood%20and%20rain%20effects&width=600&height=800&seq=manhwa-05&orientation=portrait',
    description: '连环杀手在城市中制造恐慌，天才犯罪心理分析师与凶手展开惊心动魄的智力对决。',
    longDescription: '首尔连续发生三起离奇命案，作案手法极其残忍却找不到任何线索。天才犯罪心理分析师沈夜临危受命，她必须潜入凶手的思维世界，在凶手下一次作案前将其绳之以法。但随着调查深入，她发现这一切背后隐藏着一个更大的阴谋……',
    author: '郑宇镇',
    status: '连载中',
    rating: 4.5,
    views: 890000,
    updateTime: '2026-08-02',
    tags: ['悬疑', '犯罪', '心理', '推理'],
    chapters: [
      { id: 'ch-5-1', title: '第1话 第一具尸体', number: 1, updateTime: '2026-04-01' },
      { id: 'ch-5-2', title: '第2话 凶手的签名', number: 2, updateTime: '2026-04-08' },
      { id: 'ch-5-3', title: '第3话 第二个受害者', number: 3, updateTime: '2026-04-15' },
      { id: 'ch-5-4', title: '第4话 心理画像', number: 4, updateTime: '2026-04-22' },
    ],
  },
  {
    id: 6,
    title: '社长大人请住手',
    slug: 'boss-please-stop',
    category: 'gaoxiao-richang',
    cover: 'https://readdy.ai/api/search-image?query=A%20comedy%20Korean%20manhwa%20cover%2C%20a%20chaotic%20office%20scene%20with%20funny%20expressions%2C%20bright%20and%20colorful%20art%20style%2C%20exaggerated%20facial%20expressions%2C%20manga%20illustration%20with%20humorous%20tone%20and%20warm%20lighting&width=600&height=800&seq=manhwa-06&orientation=portrait',
    description: '倒霉蛋社员的爆笑职场生活，每天都在社长的奇葩要求中求生。',
    longDescription: '王小明的职场生活简直是一场灾难。他的社长是一个脑回路清奇的奇葩，每天都在提出各种令人哭笑不得的要求——从在公司养羊驼到要求员工穿韩服上班。在这个奇葩公司里，王小明和他的同事们每天都在上演让人捧腹大笑的职场喜剧。',
    author: '刘在石',
    status: '连载中',
    rating: 4.4,
    views: 1890000,
    updateTime: '2026-08-05',
    tags: ['搞笑', '职场', '日常', '轻松'],
    chapters: [
      { id: 'ch-6-1', title: '第1话 入职第一天就崩了', number: 1, updateTime: '2026-05-01' },
      { id: 'ch-6-2', title: '第2话 羊驼来了', number: 2, updateTime: '2026-05-08' },
      { id: 'ch-6-3', title: '第3话 韩服日', number: 3, updateTime: '2026-05-15' },
      { id: 'ch-6-4', title: '第4话 团建的噩梦', number: 4, updateTime: '2026-05-22' },
      { id: 'ch-6-5', title: '第5话 社长恋爱了', number: 5, updateTime: '2026-05-29' },
    ],
  },
  {
    id: 7,
    title: '重生之商业帝国',
    slug: 'rebirth-business-empire',
    category: 'shaonian-redixue',
    cover: 'https://readdy.ai/api/search-image?query=A%20modern%20Korean%20manhwa%20cover%2C%20a%20confident%20businessman%20in%20a%20luxury%20office%20with%20cityscape%20view%2C%20sleek%20style%2C%20cool%20blue-gray%20tones%2C%20manga%20illustration%20with%20professional%20atmosphere%20and%20dramatic%20lighting&width=600&height=800&seq=manhwa-07&orientation=portrait',
    description: '破产商人重生回到二十年前，凭借前世记忆打造属于自己的商业帝国。',
    longDescription: '商业奇才陈建国在一场阴谋中失去了一切。当他再次睁开眼睛时，发现自己回到了二十年前——一切都还来得及改变的时代。带着前世的记忆和经验，他将从零开始，一步步构建属于自己的商业帝国，同时找出那些在背后陷害他的人。',
    author: '金泰亨',
    status: '连载中',
    rating: 4.7,
    views: 1670000,
    updateTime: '2026-08-04',
    tags: ['重生', '商业', '逆袭', '爽文'],
    chapters: [
      { id: 'ch-7-1', title: '第1话 回到1998', number: 1, updateTime: '2026-03-15' },
      { id: 'ch-7-2', title: '第2话 第一桶金', number: 2, updateTime: '2026-03-22' },
      { id: 'ch-7-3', title: '第3话 股市风云', number: 3, updateTime: '2026-03-29' },
    ],
  },
  {
    id: 8,
    title: '月光下的约定',
    slug: 'promise-under-moonlight',
    category: 'shaonv-lianai',
    cover: 'https://readdy.ai/api/search-image?query=A%20romantic%20Korean%20manhwa%20cover%2C%20a%20couple%20sharing%20a%20tender%20moment%20under%20moonlight%20by%20the%20sea%2C%20soft%20silver%20and%20blue%20tones%2C%20gentle%20art%20style%2C%20manga%20illustration%20with%20dreamy%20night%20atmosphere%20and%20sparkling%20water&width=600&height=800&seq=manhwa-08&orientation=portrait',
    description: '青梅竹马的两个人在月光下许下约定，十年后重逢的浪漫爱情故事。',
    longDescription: '十岁那年，林小月和江辰在故乡的月光下许下了"长大后要在一起"的约定。十年后，两人在首尔意外重逢——她成了知名插画师，他成了建筑设计师。那份童年的约定是否还作数？在月光见证下，一段跨越十年的浪漫爱情悄然绽放。',
    author: '崔秀英',
    status: '已完结',
    rating: 4.8,
    views: 1340000,
    updateTime: '2026-06-30',
    tags: ['青梅竹马', '重逢', '治愈', '甜宠'],
    chapters: [
      { id: 'ch-8-1', title: '第1话 月光下的约定', number: 1, updateTime: '2025-09-01' },
      { id: 'ch-8-2', title: '第2话 十年后的重逢', number: 2, updateTime: '2025-09-08' },
      { id: 'ch-8-3', title: '第3话 心跳的回忆', number: 3, updateTime: '2025-09-15' },
      { id: 'ch-8-4', title: '第4话 雨中的告白', number: 4, updateTime: '2025-09-22' },
      { id: 'ch-8-5', title: '第5话 幸福的约定', number: 5, updateTime: '2025-09-29' },
    ],
  },
  {
    id: 9,
    title: '龙之谷守护者',
    slug: 'dragon-valley-guardian',
    category: 'qihuan-maoxian',
    cover: 'https://readdy.ai/api/search-image?query=A%20fantasy%20Korean%20manhwa%20cover%2C%20a%20brave%20knight%20facing%20a%20majestic%20dragon%20in%20a%20mystical%20valley%2C%20epic%20scale%2C%20rich%20greens%20and%20golds%2C%20manga%20illustration%20with%20grand%20adventure%20feel%20and%20magical%20atmosphere&width=600&height=800&seq=manhwa-09&orientation=portrait',
    description: '少年与龙族签订契约成为守护者，在龙之谷中展开惊心动魄的奇幻冒险。',
    longDescription: '在人类与龙族共存的世界里，相传只有被选中的人才能成为龙之谷的守护者。孤儿少年苏烈在一次意外中与传说中的黄金巨龙签订了契约，从此踏上守护龙之谷的使命之路。邪恶势力虎视眈眈，龙之谷的秘密正等待着他去揭开。',
    author: '金南俊',
    status: '连载中',
    rating: 4.6,
    views: 1120000,
    updateTime: '2026-08-03',
    tags: ['龙', '冒险', '契约', '奇幻'],
    chapters: [
      { id: 'ch-9-1', title: '第1话 龙之谷的传说', number: 1, updateTime: '2026-04-10' },
      { id: 'ch-9-2', title: '第2话 意外的契约', number: 2, updateTime: '2026-04-17' },
      { id: 'ch-9-3', title: '第3话 守护者的试炼', number: 3, updateTime: '2026-04-24' },
    ],
  },
  {
    id: 10,
    title: '镜中的谎言',
    slug: 'lies-in-the-mirror',
    category: 'jingsong-xuanyi',
    cover: 'https://readdy.ai/api/search-image?query=A%20psychological%20thriller%20Korean%20manhwa%20cover%2C%20a%20woman%20looking%20into%20a%20cracked%20mirror%20with%20a%20distorted%20reflection%2C%20dark%20and%20eerie%20mood%2C%20cold%20tone%20colors%2C%20manga%20illustration%20with%20unsettling%20atmosphere%20and%20subtle%20horror%20elements&width=600&height=800&seq=manhwa-10&orientation=portrait',
    description: '女高中生发现镜子里的人不是自己，一场关于身份和真相的惊悚故事就此展开。',
    longDescription: '十七岁的韩素希某天照镜子时，发现镜中的自己做出了和她不一样的表情。起初以为只是疲劳产生的幻觉，但诡异的事件接连发生——镜子里的"她"似乎在试图取代现实中的她。这是一场关于身份、记忆和真相的心理惊悚游戏，镜中的谎言究竟隐藏着什么秘密？',
    author: '郑宇镇',
    status: '连载中',
    rating: 4.5,
    views: 780000,
    updateTime: '2026-08-01',
    tags: ['心理', '惊悚', '悬疑', '校园'],
    chapters: [
      { id: 'ch-10-1', title: '第1话 镜中的陌生人', number: 1, updateTime: '2026-05-10' },
      { id: 'ch-10-2', title: '第2话 不是我', number: 2, updateTime: '2026-05-17' },
      { id: 'ch-10-3', title: '第3话 被替换的记忆', number: 3, updateTime: '2026-05-24' },
    ],
  },
  {
    id: 11,
    title: '便利店夜班',
    slug: 'convenience-store-night',
    category: 'gaoxiao-richang',
    cover: 'https://readdy.ai/api/search-image?query=A%20slice-of-life%20Korean%20manhwa%20cover%2C%20a%20sleepy%20convenience%20store%20worker%20at%20night%20with%20quirky%20customers%2C%20warm%20neon%20lights%2C%20cozy%20atmosphere%2C%20manga%20illustration%20with%20relaxed%20slice-of-life%20style%20and%20gentle%20humor&width=600&height=800&seq=manhwa-11&orientation=portrait',
    description: '便利店的深夜，各色奇葩顾客轮番登场，演绎令人捧腹的日常喜剧。',
    longDescription: '大学生金志勋为了赚学费在便利店上夜班。他本以为这份工作会很无聊，没想到深夜的便利店简直是一个小型人间剧场——喝醉的大叔、失恋的女孩、深夜觅食的健身狂人……每个夜晚都有新的奇葩故事在上演，让他的打工生活变得妙趣横生。',
    author: '刘在石',
    status: '连载中',
    rating: 4.3,
    views: 1450000,
    updateTime: '2026-08-04',
    tags: ['搞笑', '日常', '治愈', '轻松'],
    chapters: [
      { id: 'ch-11-1', title: '第1话 第一个夜晚', number: 1, updateTime: '2026-06-01' },
      { id: 'ch-11-2', title: '第2话 醉汉的哲学', number: 2, updateTime: '2026-06-08' },
      { id: 'ch-11-3', title: '第3话 深夜食堂', number: 3, updateTime: '2026-06-15' },
    ],
  },
  {
    id: 12,
    title: '花与野兽',
    slug: 'flower-and-beast',
    category: 'danmei-BL',
    cover: 'https://readdy.ai/api/search-image?query=A%20BL%20Korean%20manhwa%20cover%2C%20a%20contrast%20between%20a%20gentle%20florist%20and%20a%20tough%20bodyguard%2C%20flowers%20and%20shadows%2C%20elegant%20composition%2C%20manga%20illustration%20with%20dramatic%20beauty%20and%20soft%20romantic%20undertones&width=600&height=800&seq=manhwa-12&orientation=portrait',
    description: '温柔花店老板与冷面保镖之间，一朵花串起的禁断之恋。',
    longDescription: '首尔最繁华地段的花店"春日"，老板韩在熙是一位温柔如春风的男子。某天，一位浑身散发着危险气息的男人——知名财阀的保镖队长姜赫闯入了他的花店。鲜花与利刃、温柔与冷硬，两个世界的人因为一束花而产生了不可思议的交集。',
    author: '李恩在',
    status: '连载中',
    rating: 4.8,
    views: 1780000,
    updateTime: '2026-08-05',
    tags: ['都市', '反差', '唯美', '治愈'],
    chapters: [
      { id: 'ch-12-1', title: '第1话 买花的男人', number: 1, updateTime: '2026-02-20' },
      { id: 'ch-12-2', title: '第2话 第二次相遇', number: 2, updateTime: '2026-02-27' },
      { id: 'ch-12-3', title: '第3话 花语', number: 3, updateTime: '2026-03-06' },
      { id: 'ch-12-4', title: '第4话 危险的温柔', number: 4, updateTime: '2026-03-13' },
    ],
  },
];

export const faqs = [
  {
    question: '韩漫漫画网的漫画是免费的吗？',
    answer: '是的，韩漫漫画网上所有韩国漫画资源完全免费。我们致力于为广大韩漫爱好者提供优质的免费阅读体验，无需任何付费即可畅读全部内容。',
  },
  {
    question: '网站支持哪些设备阅读？',
    answer: '韩漫漫画网全面支持PC端、平板和手机移动端阅读。下拉式排版专为移动设备优化，让您随时随地享受流畅的漫画阅读体验。',
  },
  {
    question: '漫画更新频率是多少？',
    answer: '我们每日更新最新韩漫资源，热门连载漫画通常每周更新1-2话。您可以在首页"最新更新"板块查看每日上新的漫画内容。',
  },
  {
    question: '如何找到我喜欢的漫画类型？',
    answer: '您可以通过顶部导航栏的分类菜单浏览不同类型的漫画。我们提供少年热血、少女恋爱、奇幻冒险、耽美BL、惊悚悬疑、搞笑日常等多种分类，点击即可查看对应分类的全部漫画。',
  },
  {
    question: '网站上的漫画是否有删减？',
    answer: '韩漫漫画网承诺提供无删减的原版漫画内容，完整呈现原版故事和画质。我们尊重原作者和作品的完整性，让您享受纯正的韩国漫画阅读体验。',
  },
  {
    question: '如何联系韩漫漫画网？',
    answer: '您可以通过"关于我们"页面中的联系表单与我们取得联系，我们会在24小时内回复您的反馈和建议。',
  },
];

export const testimonials = [
  {
    name: '小王子',
    content: '这个网站真的太棒了！资源超级全，更新速度快，而且画质清晰。终于找到了一个能安心看韩漫的地方！',
    rating: 5,
    date: '2026-07-28',
  },
  {
    name: '漫迷阿琳',
    content: '下拉式阅读体验非常好，手机上看特别方便。分类也很清晰，找漫画特别容易。强烈推荐给所有韩漫爱好者！',
    rating: 5,
    date: '2026-07-25',
  },
  {
    name: '追漫达人',
    content: '无删减这一点就值得满分！画质和翻译质量都很高，是我用过的最好的免费韩漫网站。每天都要上来看看有没有更新。',
    rating: 5,
    date: '2026-07-20',
  },
  {
    name: '深夜读者',
    content: '界面简洁清爽，没有乱七八糟的广告弹窗，阅读体验非常好。收藏功能也很实用，可以随时追踪追更进度。',
    rating: 4,
    date: '2026-07-15',
  },
];